import React from 'react';
import { Link } from "react-router-dom"
import ReactMarkdown from 'react-markdown'


import { CognitoUserPool, CognitoUserAttribute, CognitoUser, AuthenticationDetails } from 'amazon-cognito-identity-js';
import Auth from '../Auth'

import Nav from './Nav'

import './Profile.css'


class Profile extends React.Component {

	attributes = ['name', 'CompanyName', 'AWSRoleARN']

	constructor(props) {
		super(props)
		this.state = {}
		this.attributes.forEach(a => {
			// console.log(a, this);
			this[a] = React.createRef()
		})


	}
	async componentDidMount() {
		this.updateProfileData()

		let accountSetupResponse = await fetch(require('./account-setup.md'))
		let accountSetup = await accountSetupResponse.text()
		// console.log(accountSetup);
		this.setState({ accountSetup: accountSetup })

	}
	async componentDidUpdate(prevProps) {
		try {
			if (prevProps.appState !== this.props.appState) {
				this.updateProfileData()
			}
		} catch (e) {
		}
	}
	updateProfileData = () => {
		if (!this.props.appState.currentUserAttributes) return
		this.attributes.forEach(a => this[a].current && (this[a].current.value = this.props.appState.currentUserAttributes[this.attributeKey(a)] || ''))
		// console.log(this.props.appState.currentUser.getUsername());
	}
	attributeKey(attribute) {
		if (attribute == 'name') return attribute
		return 'custom:' + attribute
	}







	handleSubmit = async (event) => {
		event.preventDefault()
		// console.log(this.AWSKeyID.current.value)

		try {

			this.setState({ error: null, success: undefined })

			// if (!this.AWSKeyID.current.value) throw 'Please enter your AWS Key ID'
			// if (!this.AWSKey.current.value) throw 'Please enter your AWS Key'


			let data = {}
			this.attributes.forEach(a => this[a].current && this[a].current.value && (data[a] = this[a].current.value))
			console.log(data);


			var attributeList = [];
			for (const a in data) {
				attributeList.push(new CognitoUserAttribute({ Name: this.attributeKey(a), Value: data[a] }));
			}
			this.props.appState.currentUser.updateAttributes(attributeList, (err, result) => {
				if (err) {
					alert(err.message || JSON.stringify(err));
					return;
				}
				// console.log('call result: ' + result);

				// console.log('done', data);
				this.setState({ success: true })

				Auth.update()

				let { from } = this.props.location.state || { from: { pathname: "/" } };
				this.props.history.push(from);

			});





		} catch (e) {
			console.log(e.message || e);
			this.setState({ error: e.message || e })
		}
	}




	render() {
		return (
			<div>
				<Nav {...this.props} ></Nav>

				<div className="container my-5">
					<div className="h2  text-primary my-5">Account Settings</div>


					<form onSubmit={this.handleSubmit} className="" >

						<div className="bg-white shadow-sm rounded p-4 mb-4">
							<div className="row">
								<div className="col-md-3 font-weight-500">
									Personal Information
								</div>
								<div className="col-md-9">
									<div className="form-group">
										<label htmlFor="name" className="small text-uppercase ">Name</label>
										<input type="name" className="form-control " id="name" ref={this.name} />
									</div>
									<div className="form-group">
										<label htmlFor="CompanyName" className="small text-uppercase ">Company Name</label>
										<input type="text" className="form-control " id="CompanyName" ref={this.CompanyName} />
									</div>
								</div>
							</div>
						</div>
						<div className="bg-white shadow-sm rounded p-4 mb-4">
							<div className="row">
								<div className="col-md-3 font-weight-500">
									AWS Configuration
								</div>
								<div className="col-md-9">
									<div className="form-group">
										<label htmlFor="ExternalId" className="small  ">ExternalId</label>
										<div className="text-monospace">{this.props.appState.currentUser.getUsername()}</div>
										{/* <input type="text" className="form-control " id="AWSKeyID" ref={this.AWSKeyID} /> */}
									</div>
									<div className="form-group">
										<label htmlFor="AWSRoleARN" className="small  ">AWS Role ARN</label>
										<input type="text" className="form-control " id="AWSRoleARN" ref={this.AWSRoleARN} />
										{/* <small className="form-text text-muted">AWS Key is only writeable for security purposes.</small> */}
									</div>

									<div className="btn btn-link btn-sm  p-0" onClick={() => this.setState({ showAWSConfigHelp: !this.state.showAWSConfigHelp })}><u>{this.state.showAWSConfigHelp ? 'Hide' : 'Show'} AWS Configuration instructions</u></div>
									{this.state.showAWSConfigHelp &&
										<ReactMarkdown source={this.state.accountSetup} />
									}

								</div>
							</div>
						</div>


						<div className="small text-danger text-center my-4 ">{this.state.error}</div>
						<div className="text-center my-4">
							<button type="submit" className="btn btn-primary btn-lg px-4  text-capitalize">Save</button>
						</div>
						{this.state.success && <div className="small text-success text-center my-4 ">Saved</div>}

					</form>


				</div>
			</div>

		)
	}


}

export default Profile
